// extracted by mini-css-extract-plugin
module.exports =  {"sessionThumbnails":"kUTrUGCSUBlpk8ESk9Yo","canvas":"oe4lxYa8OAvbqeVpimEl","title":"cYRa6SV4d2TijqBwAqJr","canvasButton":"_8vejYeEhcDMN8AoRWoI"};